import { render, staticRenderFns } from "./index.html?vue&type=template&id=c98f6bfc&scoped=true&"
import script from "./prv-page-loader.vue?vue&type=script&lang=js&"
export * from "./prv-page-loader.vue?vue&type=script&lang=js&"
import style0 from "./index.styl?vue&type=style&index=0&id=c98f6bfc&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98f6bfc",
  null
  
)

export default component.exports